import React, { useState, useEffect } from 'react';
import { fishDataFromCsv } from '../data/fishDataFromCsv.js';

const About = () => {
  const [currentFishData, setCurrentFishData] = useState([]);
  
  useEffect(() => {
    // Load fish data from localStorage or fallback to default fishData
    const savedFish = localStorage.getItem('saltfishy_fish_inventory');
    if (savedFish) {
      try {
        const parsedFish = JSON.parse(savedFish);
        setCurrentFishData(parsedFish);
      } catch (error) {
        console.warn('Error loading fish data:', error);
        setCurrentFishData(fishDataFromCsv);
      }
    } else {
      setCurrentFishData(fishDataFromCsv);
    }
    if (savedFish) {
      try {
        const parsedFish = JSON.parse(savedFish);
        setCurrentFishData(parsedFish);
      } catch (error) {
        console.warn('Error loading fish data:', error);
        setCurrentFishData([]);
      }
    } else {
      setCurrentFishData([]);
    }
  }, []);

  return (
    <div style={{ background: 'var(--background)', minHeight: '100vh', paddingTop: '80px' }}>
      <div className="container" style={{ paddingBottom: '80px' }}>
        
        {/* Hero Section */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            borderRadius: '50px',
            background: 'hsl(200, 85%, 25%, 0.1)',
            color: 'var(--primary)',
            marginBottom: '1rem'
          }}>
            <span style={{ fontSize: '1.5rem' }}>🏝️</span>
            <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>About SaltFishy</span>
          </div>
          <h1 className="font-display" style={{
            fontSize: 'clamp(3rem, 8vw, 5rem)',
            fontWeight: 'bold',
            color: 'var(--foreground)',
            marginBottom: '1rem'
          }}>
            From the Heart of the Maldives
          </h1>
          <p style={{
            color: 'var(--muted-foreground)',
            maxWidth: '42rem',
            margin: '0 auto',
            fontSize: '1.25rem',
            lineHeight: '1.6'
          }}>
            Discover our story of bringing the pristine beauty of Maldivian marine life to aquarium enthusiasts worldwide.
          </p>
        </div>
        
        {/* Enhanced About Section */}
        <section style={{ padding: '3rem 0', marginBottom: '4rem' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '3rem', 
            alignItems: 'center' 
          }}>
            {/* Content */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              <div>
                <span style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: 'var(--primary)',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}>
                  Our Story
                </span>
                <h2 className="font-display" style={{
                  fontSize: 'clamp(2.5rem, 6vw, 3rem)',
                  fontWeight: 'bold',
                  color: 'var(--foreground)',
                  marginTop: '0.5rem',
                  lineHeight: '1.2'
                }}>
                  Passion for the
                  <span style={{ 
                    display: 'block', 
                    background: 'var(--gradient-ocean)', 
                    WebkitBackgroundClip: 'text', 
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}>
                    Ocean's Beauty
                  </span>
                </h2>
              </div>

              <p style={{
                fontSize: '1.125rem',
                color: 'var(--muted-foreground)',
                lineHeight: '1.6'
              }}>
                SaltFishy was founded by marine aquarium enthusiasts who understand the joy of 
                keeping beautiful, healthy fish. We're committed to providing the highest quality 
                marine fish from the pristine waters of the Maldives while prioritizing their health and your satisfaction.
              </p>

              <p style={{
                fontSize: '1rem',
                color: 'var(--muted-foreground)',
                lineHeight: '1.6'
              }}>
                Every fish in our collection goes through a rigorous quarantine process, 
                ensuring they're disease-free and eating well before they're available for sale. 
                Our team of experts is always here to help you choose the perfect fish for your 
                aquarium and provide guidance on their care.
              </p>

              {/* Features Grid */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(2, 1fr)', 
                gap: '1.5rem', 
                paddingTop: '1rem' 
              }}>
                {[
                  {
                    icon: '🛡️',
                    title: 'Quality Guaranteed',
                    description: 'Every fish is carefully inspected and quarantined for 2 weeks before sale.'
                  },
                  {
                    icon: '🚚',
                    title: 'Safe Shipping',
                    description: 'Temperature-controlled packaging ensures your fish arrive healthy and stress-free.'
                  },
                  {
                    icon: '❤️',
                    title: 'Expert Care',
                    description: 'Our team provides ongoing support and advice for your marine aquarium journey.'
                  },
                  {
                    icon: '🏆',
                    title: 'Premium Selection',
                    description: 'We source only the finest specimens from trusted collectors in the Maldives.'
                  }
                ].map((feature, index) => (
                  <div 
                    key={feature.title}
                    className="animate-fade-in"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div style={{
                      width: '3rem',
                      height: '3rem',
                      borderRadius: '0.75rem',
                      background: 'hsl(200, 85%, 25%, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '0.75rem',
                      fontSize: '1.5rem',
                      transition: 'background 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.background = 'hsl(200, 85%, 25%, 0.2)'}
                    onMouseLeave={(e) => e.target.style.background = 'hsl(200, 85%, 25%, 0.1)'}
                    >
                      {feature.icon}
                    </div>
                    <h3 style={{
                      fontWeight: '600',
                      color: 'var(--foreground)',
                      marginBottom: '0.25rem',
                      fontSize: '1rem'
                    }}>
                      {feature.title}
                    </h3>
                    <p style={{
                      fontSize: '0.875rem',
                      color: 'var(--muted-foreground)',
                      lineHeight: '1.5'
                    }}>
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Visual */}
            <div style={{ position: 'relative' }}>
              <div style={{
                aspectRatio: '1',
                borderRadius: '1rem',
                background: 'var(--gradient-ocean)',
                overflow: 'hidden',
                boxShadow: 'var(--shadow-elevated)',
                position: 'relative'
              }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <div style={{ textAlign: 'center', color: 'white', padding: '2rem' }}>
                    <div className="font-display" style={{ 
                      fontSize: 'clamp(3rem, 8vw, 4.5rem)', 
                      fontWeight: 'bold', 
                      marginBottom: '1rem' 
                    }}>
                      5+
                    </div>
                    <div style={{ fontSize: '1.25rem', fontWeight: '500', marginBottom: '0.5rem' }}>
                      Years of Experience
                    </div>
                    <div style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '1rem' }}>
                      Serving marine enthusiasts from the Maldives
                    </div>
                  </div>
                </div>
                
                {/* Decorative bubbles */}
                {[...Array(5)].map((_, i) => (
                  <div
                    key={i}
                    className="animate-bubble"
                    style={{
                      position: 'absolute',
                      width: '2rem',
                      height: '2rem',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.1)',
                      left: `${20 + i * 15}%`,
                      animationDelay: `${i * 2}s`,
                      animationDuration: `${5 + i}s`,
                    }}
                  />
                ))}
              </div>
              
              {/* Floating card */}
              <div style={{
                position: 'absolute',
                bottom: '-1.5rem',
                left: '-1.5rem',
                background: 'var(--card)',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                boxShadow: 'var(--shadow-elevated)',
                border: '1px solid rgba(var(--border), 0.5)',
                maxWidth: '240px',
                animation: 'float 3s ease-in-out infinite'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  <div style={{
                    width: '3.5rem',
                    height: '3.5rem',
                    borderRadius: '50%',
                    background: 'var(--gradient-coral)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.5rem'
                  }}>
                    🏆
                  </div>
                  <div>
                    <div className="font-display" style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: 'bold', 
                      color: 'var(--foreground)' 
                    }}>
                      {currentFishData.length}+
                    </div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--muted-foreground)' }}>
                      Fish Species
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Values */}
        <div className="grid" style={{ marginBottom: '60px' }}>
          <div className="card">
            <h3 style={{ marginBottom: '20px', color: '#74b9ff', textAlign: 'center' }}>🎯 Our Mission</h3>
            <p style={{ lineHeight: '1.8', textAlign: 'center' }}>
              To bring the wonder of coral reefs into homes worldwide while promoting marine conservation 
              and sustainable aquarium keeping practices.
            </p>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: '20px', color: '#00cec9', textAlign: 'center' }}>🌱 Sustainability</h3>
            <p style={{ lineHeight: '1.8', textAlign: 'center' }}>
              We partner only with certified sustainable breeders and support coral reef restoration 
              projects with 5% of our profits.
            </p>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: '20px', color: '#fdcb6e', textAlign: 'center' }}>📚 Education</h3>
            <p style={{ lineHeight: '1.8', textAlign: 'center' }}>
              Every purchase includes detailed care guides and access to our marine biology experts 
              for ongoing support and advice.
            </p>
          </div>
        </div>

        {/* Team */}
        <div className="card" style={{ marginBottom: '40px' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '40px', color: '#2d3436' }}>Meet Our Team</h2>
          <div className="grid">
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '60px', marginBottom: '15px' }}>👩‍🔬</div>
              <h4>Rifath Abdulla</h4>
              <p style={{ color: '#74b9ff', fontWeight: 'bold' }}>Founder </p>
              <p>20+ years of reef fish experience and Pole and line fishing</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '60px', marginBottom: '15px' }}>🐟</div>
              <h4> Ali Abdul Rahman</h4>
              <p style={{ color: '#74b9ff', fontWeight: 'bold' }}>Head Aquaculturist</p>
              <p>Specialist in rare species breeding and quarantine protocols</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '60px', marginBottom: '15px' }}>📦</div>
              <h4>Emma Coral</h4>
              <p style={{ color: '#74b9ff', fontWeight: 'bold' }}>Shipping & Logistics Manager</p>
              <p>Expert in safe fish transportation and international shipping</p>
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="card">
          <h2 style={{ textAlign: 'center', marginBottom: '40px', color: '#2d3436' }}>Our Certifications</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px', textAlign: 'center' }}>
            <div>
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>🏅</div>
              <h4>MFA Certified</h4>
              <p>Catch Certificate issued by the Ministry of Fisheries and Agriculture</p>
            </div>
            <div>
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>🏛️</div>
              <h4>Health Certificate</h4>
              <p>Issued by the Maldives Food and Drug Authority</p>
            </div>
            <div>
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>🔬</div>
              <h4>IATA Certified</h4>
              <p>International air transport standards for live animals</p>
            </div>
            <div>
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>💎</div>
              <h4>Quality Guarantee</h4>
              <p>30-day health guarantee on all fish purchases</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
